export const VIDEO_PLUGIN_KEY = 'video';
export const VIDEO_TYPE = 'video';
